import { JOINING_APP_ROUTES } from "../../../../config/common";

// add the page id here to redirect to next pages
export const completedGradPagesMap: Record<number, string> = {
  2: JOINING_APP_ROUTES.GRADUATE.DETAILS,
  10: JOINING_APP_ROUTES.GRADUATE.REVIEW, // we want to send them back here before selecting plan for peace of mind
  22: JOINING_APP_ROUTES.GRADUATE.REVIEW,
  27: JOINING_APP_ROUTES.GRADUATE.ABOUT_YOU,
};

// pages id for reference
// 1,Eligibility and Previous Membership
// 2,About You
// 3,Your Professional Details
// 4,Your Agent
// 5,Your Physical Appearance
// 6,Your Skills
// 7,Your Credits
// 8,Your Photographs
// 10,Review Application
// 11,Payment
// 12,Finished
// 18,Your Previous Membership
// 21,About
// 22,Your Details
// 23,Physical Appearance
// 24,Skills
// 25,Credits
// 26,Photograph
// 27,Welcome
// 28,Pathway
// 29,Eligibility
